import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "../../../../index.css";
import Arrow from "../../../Helpers/icons/Arrow";
import IRGlogo from "../../../../images/IRG_logo_Teal1.png";
import "../../../../components/Collections/IRG/IRG.css";
import "../../../../components/Helpers/icons/Badges.css";
// Web

export default function Navbar({ className }) {
  const [categoryToggle, setToggle] = useState(false);
  const [elementsSize, setSize] = useState("0px");
  // const getItems = document.querySelectorAll(`.categories-list li`).length;
  // if (categoryToggle && getItems > 0) {
  //   setSize(`${40 * getItems}px`);
  // }
  const handler = () => {
    setToggle(!categoryToggle);
  };
  useEffect(() => {
    if (categoryToggle) {
      const getItems = document.querySelectorAll(`.categories-list li`).length;
      if (categoryToggle && getItems > 0) {
        setSize(`${42 * getItems}px`);
      }
    } else {
      setSize(`0px`);
    }
  }, [categoryToggle]);

  // Validate user
  const userSignin = useSelector((state) => state.userSignin);
  const { userInfo, userLoading, userError } = userSignin;

  // Permissions
  const shoppingCartPermission = userInfo?.result.user.permissions.ShoppingCart;
  const placeOrderPermission = userInfo?.result.user.permissions.PlaceOrder;

  // State for handling IRG popup visibility and passcode entry
  const [isIRGPopupOpen, setIsIRGPopupOpen] = useState(false);
  const [enteredIRGPasscode, setEnteredIRGPasscode] = useState("");
  const [failedAttempts, setFailedAttempts] = useState(0); // Track failed attempts

  const [passcodePass, setPasscodePass] = useState("hide-password");
  const correctPasscode = "E-prosper4!";
  const [showIRGError, setShowIRGError] = useState(false); // State for error message

  // Function to get token from localStorage and check if it's expired
  const getIRGToken = () => {
    const token = localStorage.getItem("IRGAccesstoken");
    const tokenExpiry = localStorage.getItem("IRGtokenExpiry");

    if (!token || !tokenExpiry) {
      return null;
    }

    const now = new Date().getTime();
    if (now > tokenExpiry) {
      localStorage.removeItem("IRGAccesstoken");
      localStorage.removeItem("IRGtokenExpiry");
      return null;
    }

    return token;
  };

  // Function to open the popup
  const handleIRGButtonClick = () => {
    const token = getIRGToken();
    if (token) {
      // Redirect directly if token exists
      window.location.href = "/Collection/IRGAll";
    } else {
      // Open popup if no valid token
      setIsIRGPopupOpen(true);
    }
  };

  // Function to close the popup
  const closeIRGPopup = () => {
    setFailedAttempts(0);

    setIsIRGPopupOpen(false);
    setShowIRGError(false);
    setEnteredIRGPasscode(""); // Reset passcode input on close
  };

  // Function to generate token with expiration and store in localStorage
  const generateTokenWithAutoClear = (expiryMinutes = 90) => {
    const IRGtoken = Math.random().toString(36).substring(2); // Simple token generator
    const IRGexpiryTime = new Date().getTime() + expiryMinutes * 60000;

    localStorage.setItem("IRGAccesstoken", IRGtoken);
    localStorage.setItem("IRGtokenExpiry", IRGexpiryTime);

    // Auto-clear token after expiration time
    setTimeout(() => {
      localStorage.removeItem("IRGAccesstoken");
      localStorage.removeItem("IRGtokenExpiry");
    }, expiryMinutes * 60000);

    return IRGtoken;
  };

  // Function to verify IRG passcode
  const verifyIRGPasscode = () => {
    // Step 1: Check if an existing valid token is already in local storage
    const hasIRGtoken = getIRGToken();
    if (!hasIRGtoken) {
      // Step 2 : Validate the entered password
      if (enteredIRGPasscode === correctPasscode) {
        // Step 3 : Reset failed attempts if passcode is correct
        setFailedAttempts(0);

        // Step 4 : Generate token with expiration
        generateTokenWithAutoClear(180);

        // Step 5 : Redirect to IRG page
        closeIRGPopup();
        window.location.href = "/Collection/IRGAll";
      } else {
        // If the password is incorrect, increment the failed attempts
        const newFailedAttempts = failedAttempts + 1;
        setFailedAttempts(newFailedAttempts);
        setShowIRGError(true); // Show error message
      }
    }
  };

  // Mouseover of Quick Order
  const handleHoverQuickOrder = (e) => {
    e.currentTarget.style.background = "#F5F5F5"; // Very light gray background on hover/focus
    e.currentTarget.style.color = "#04ADD1"; // Keep text color as blue on hover/focus
    e.currentTarget.style.border = "2px solid #F5F5F5"; // Very light gray border on hover/focus

    // Add a hover class to both rect elements inside the SVG
    const svgRects = e.currentTarget.querySelectorAll("svg rect");
    svgRects.forEach((rect) => {
      rect.classList.add("hover-svg-qo"); // Add class to apply hover effect
    });
  };

  const handleHoverOutQuickOrder = (e) => {
    e.currentTarget.style.background = "#FFFFFF"; // Revert to white background
    e.currentTarget.style.color = "#04ADD1"; // Keep text color as blue
    e.currentTarget.style.border = "2px solid #04ADD1"; // Revert to blue border

    // Remove the hover class from both rect elements inside the SVG to revert the color
    const svgRects = e.currentTarget.querySelectorAll("svg rect");
    svgRects.forEach((rect) => {
      rect.classList.remove("hover-svg-qo"); // Remove the hover class to revert to original styles
      rect.classList.add("default-svg-qo"); // Add a default class to apply the original blue fill
    });
  };

  // Mouseover of Order Import
  const handleHoverOrderImport = (e) => {
    e.currentTarget.style.background = "#0085A2"; // Change background color on hover/focus
    e.currentTarget.style.color = "#ffffff"; // Change text color on hover/focus
    e.currentTarget.style.border = "2px solid #0085A2"; // Change border color on hover/focus

    // Add a hover class to both rect elements inside the SVG
    const svgRects = e.currentTarget.querySelectorAll("svg rect");
    svgRects.forEach((rect) => {
      rect.classList.add("hover-svg-oi"); // Add class to apply hover effect
    });
  };

  const handleHoverOutOrderImport = (e) => {
    e.currentTarget.style.background = "#04ADD1"; // Revert to original background color
    e.currentTarget.style.color = "#ffffff"; // Revert to original text color
    e.currentTarget.style.border = "2px solid #FFFFFF"; // Revert to original border color

    // Remove the hover class from both rect elements inside the SVG to revert the color
    const svgRects = e.currentTarget.querySelectorAll("svg rect");
    svgRects.forEach((rect) => {
      rect.classList.remove("hover-svg-oi"); // Remove the hover class to revert to original styles
      rect.classList.add("default-svg-oi"); // Add a default class to apply the original white fill
    });
  };

  const showPasscode = (value) => {
    const password = document.getElementById(`${value}`);
    if (value && value === "entered_password") {
      if (password.type === "password") {
        password.type = "text";
        setPasscodePass("show-password");
      } else {
        password.type = "password";
        setPasscodePass("hide-password");
      }
    }
  };

  return (
    /* <div
      className={`nav-widget-wrapper w-full bg-qyellow h-[60px] relative z-30
      className={`nav-widget-wrapper w-full nav-bg-teal h-[60px] relative z-30  ${
        className || ""
      }`}
    >*/

    <div
      className={`nav-widget-wrapper w-full h-[60px] relative z-30  ${
        className || ""
      }`}
      style={{ backgroundColor: "#04ADD1" }}
    >
      <div className="container-x mx-auto h-full">
        <div className="w-full h-full relative">
          <div className="w-full h-full flex justify-between items-center">
            {/* <div className="category-and-nav flex xl:space-x-7 space-x-3 items-center"> */}
            <div className="category-and-nav flex l:space-x-7 space-x-3 items-center">
              {/* <div className="category w-[270px] h-[53px] bg-white px-5 rounded-t-md mt-[6px] relative"> */}
              <div className="category w-[250px] h-[53px] bg-white px-5 rounded-t-md mt-[6px] relative">
                <button
                  onClick={handler}
                  type="button"
                  className="w-full h-full flex justify-between items-center"
                >
                  <div className="flex space-x-3 items-center">
                    {/* <span>
                      <svg
                        width="14"
                        height="9"
                        viewBox="0 0 14 9"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect width="14" height="1" fill="#1D1D1D" />
                        <rect y="8" width="14" height="1" fill="#1D1D1D" />
                        <rect y="4" width="10" height="1" fill="#1D1D1D" />
                      </svg>
                    </span> */}
                    <span
                      style={{
                        color: "#090909",
                        fontFamily: "Roboto",
                        fontSize: "16px",
                        fontStyle: "normal",
                        fontWeight: "700",
                        lineHeight: "normal",
                        marginLeft: "15px",
                      }}
                    >
                      SHOP ALL
                    </span>
                  </div>
                  {/*  <div>
                    <Arrow
                      width="5.78538"
                      height="1.28564"
                      className="fill-current text-qblacktext"
                    />
                    </div> */}
                </button>
                {categoryToggle && (
                  <div
                    className="fixed top-0 left-0 w-full h-full -z-10"
                    onClick={handler}
                  ></div>
                )}
                <div
                  className="category-dropdown w-full absolute left-0 top-[53px] overflow-hidden"
                  style={{ height: `${elementsSize} ` }}
                >
                  <ul className="categories-list">
                    <li className="category-item">
                      <a href="/Collection/Bestee">
                        <div className=" flex justify-between items-center px-5 h-10 bg-white hover:bg-qyellow transition-all duration-300 ease-in-out cursor-pointer">
                          <div className="flex items-center space-x-6">
                            <span> 
                            </span>
                            <span className="text-xs font-400">BESTEE</span>
                          </div>
                          <div>
                            <span>
                              <svg
                                width="6"
                                height="9"
                                viewBox="0 0 6 9"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="1.49805"
                                  y="0.818359"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(45 1.49805 0.818359)"
                                  fill="#1D1D1D"
                                />
                                <rect
                                  x="5.58984"
                                  y="4.90918"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(135 5.58984 4.90918)"
                                  fill="#1D1D1D"
                                />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li className="category-item">
                      <a href="/Collection/Blaze">
                        <div className="flex justify-between items-center px-5 h-10 bg-white hover:bg-qyellow transition-all duration-300 ease-in-out cursor-pointer">
                          <div className="flex items-center space-x-6">
                            <span> 
                            </span>
                            <span className="text-xs font-400">
                              BLAZE
                            </span>
                          </div>
                          <div>
                            <span>
                              <svg
                                width="6"
                                height="9"
                                viewBox="0 0 6 9"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="1.49805"
                                  y="0.818359"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(45 1.49805 0.818359)"
                                  fill="#1D1D1D"
                                />
                                <rect
                                  x="5.58984"
                                  y="4.90918"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(135 5.58984 4.90918)"
                                  fill="#1D1D1D"
                                />
                              </svg>{" "}
                            </span>
                          </div>
                        </div>
                      </a>
                    </li>
                     <li className="category-item">
                      <a href="/Collection/BlazeLite">
                        <div className="flex justify-between items-center px-5 h-10 bg-white hover:bg-qyellow transition-all duration-300 ease-in-out cursor-pointer">
                          <div className="flex items-center space-x-6">
                            <span> 
                            </span>
                            <span className="text-xs font-400">
                              BLAZE LITE
                            </span>
                          </div>
                          <div>
                            <span>
                              <svg
                                width="6"
                                height="9"
                                viewBox="0 0 6 9"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="1.49805"
                                  y="0.818359"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(45 1.49805 0.818359)"
                                  fill="#1D1D1D"
                                />
                                <rect
                                  x="5.58984"
                                  y="4.90918"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(135 5.58984 4.90918)"
                                  fill="#1D1D1D"
                                />
                              </svg>{" "}
                            </span>
                          </div>
                        </div>
                      </a>
                    </li>
                     <li className="category-item">
                      <a href="/Collection/BlazeScuba">
                        <div className="flex justify-between items-center px-5 h-10 bg-white hover:bg-qyellow transition-all duration-300 ease-in-out cursor-pointer">
                          <div className="flex items-center space-x-6">
                            <span> 
                            </span>
                            <span className="text-xs font-400">
                              BLAZE SCUBA
                            </span>
                          </div>
                          <div>
                            <span>
                              <svg
                                width="6"
                                height="9"
                                viewBox="0 0 6 9"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="1.49805"
                                  y="0.818359"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(45 1.49805 0.818359)"
                                  fill="#1D1D1D"
                                />
                                <rect
                                  x="5.58984"
                                  y="4.90918"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(135 5.58984 4.90918)"
                                  fill="#1D1D1D"
                                />
                              </svg>{" "}
                            </span>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li className="category-item">
                      <a href="/Collection/Blossom">
                        <div className=" flex justify-between items-center px-5 h-10 bg-white hover:bg-qyellow transition-all duration-300 ease-in-out cursor-pointer">
                          <div className="flex items-center space-x-6">
                            <span> 
                            </span>
                            <span className="text-xs font-400">BLOSSOM</span>
                          </div>
                          <div>
                            <span>
                              <svg
                                width="6"
                                height="9"
                                viewBox="0 0 6 9"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="1.49805"
                                  y="0.818359"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(45 1.49805 0.818359)"
                                  fill="#1D1D1D"
                                />
                                <rect
                                  x="5.58984"
                                  y="4.90918"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(135 5.58984 4.90918)"
                                  fill="#1D1D1D"
                                />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li className="category-item">
                      <a href="/Collection/BlossomSignature">
                        <div className="flex justify-between items-center px-5 h-10 bg-white hover:bg-qyellow transition-all duration-300 ease-in-out cursor-pointer">
                          <div className="flex items-center space-x-6">
                            <span> 
                            </span>
                            <span className="text-xs font-400">
                              BLOSSOM SIGNATURE
                            </span>
                          </div>
                          <div>
                            <span>
                              <svg
                                width="6"
                                height="9"
                                viewBox="0 0 6 9"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="1.49805"
                                  y="0.818359"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(45 1.49805 0.818359)"
                                  fill="#1D1D1D"
                                />
                                <rect
                                  x="5.58984"
                                  y="4.90918"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(135 5.58984 4.90918)"
                                  fill="#1D1D1D"
                                />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li className="category-item">
                      <a href="/Collection/Core">
                        <div className=" flex justify-between items-center px-5 h-10 bg-white hover:bg-qyellow transition-all duration-300 ease-in-out cursor-pointer">
                          <div className="flex items-center space-x-6">
                            <span> 
                            </span>
                            <span className="text-xs font-400">CORE</span>
                          </div>
                          <div>
                            <span>
                              <svg
                                width="6"
                                height="9"
                                viewBox="0 0 6 9"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="1.49805"
                                  y="0.818359"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(45 1.49805 0.818359)"
                                  fill="#1D1D1D"
                                />
                                <rect
                                  x="5.58984"
                                  y="4.90918"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(135 5.58984 4.90918)"
                                  fill="#1D1D1D"
                                />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </a>
                    </li>

                    {/* Hide Embrace Only for Unimarket (UNIM10FL) */}
                    {!(
                      userInfo?.result?.user?.userId === 559 &&
                      userInfo?.result?.user?.loginId === "UNIM10FL"
                    ) && (
                      <li className="category-item">
                        <a href="/Collection/EMBRACE">
                          <div className="flex justify-between items-center px-5 h-10 bg-white hover:bg-qyellow transition-all duration-300 ease-in-out cursor-pointer">
                            <div className="flex items-center space-x-6">
                              <span></span>
                              <span className="text-xs font-400">EMBRACE</span>
                            </div>
                            <div>
                              <span>
                                <svg
                                  width="6"
                                  height="9"
                                  viewBox="0 0 6 9"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <rect
                                    x="1.49805"
                                    y="0.818359"
                                    width="5.78538"
                                    height="1.28564"
                                    transform="rotate(45 1.49805 0.818359)"
                                    fill="#1D1D1D"
                                  />
                                  <rect
                                    x="5.58984"
                                    y="4.90918"
                                    width="5.78538"
                                    height="1.28564"
                                    transform="rotate(135 5.58984 4.90918)"
                                    fill="#1D1D1D"
                                  />
                                </svg>
                              </span>
                            </div>
                          </div>
                        </a>
                      </li>
                    )}
                    <li className="category-item">
                      <a href="/Collection/EON">
                        <div className="flex justify-between items-center px-5 h-10 bg-white hover:bg-qyellow transition-all duration-300 ease-in-out cursor-pointer">
                          <div className="flex items-center space-x-6">
                            <span> 
                            </span>
                            <span className="text-xs font-400">EON </span>
                          </div>
                          <div>
                            <span>
                              <svg
                                width="6"
                                height="9"
                                viewBox="0 0 6 9"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="1.49805"
                                  y="0.818359"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(45 1.49805 0.818359)"
                                  fill="#1D1D1D"
                                />
                                <rect
                                  x="5.58984"
                                  y="4.90918"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(135 5.58984 4.90918)"
                                  fill="#1D1D1D"
                                />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </a>
                    </li>
                    
                    <li className="category-item">
                      <a href="/Collection/Focus">
                        <div className="flex justify-between items-center px-5 h-10 bg-white hover:bg-qyellow transition-all duration-300 ease-in-out cursor-pointer">
                          <div className="flex items-center space-x-6">
                            <span> 
                            </span>
                            <span className="text-xs font-400">FOCUS</span>
                          </div>
                          <div>
                            <span>
                              <svg
                                width="6"
                                height="9"
                                viewBox="0 0 6 9"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="1.49805"
                                  y="0.818359"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(45 1.49805 0.818359)"
                                  fill="#1D1D1D"
                                />
                                <rect
                                  x="5.58984"
                                  y="4.90918"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(135 5.58984 4.90918)"
                                  fill="#1D1D1D"
                                />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </a>
                    </li>

                    <li className="category-item">
                      <a href="/Collection/Knits">
                        <div className=" flex justify-between items-center px-5 h-10 bg-white hover:bg-qyellow transition-all duration-300 ease-in-out cursor-pointer">
                          <div className="flex items-center space-x-6">
                            <span> 
                            </span>
                            <span className="text-xs font-400">KNITS</span>
                          </div>
                          <div>
                            <span>
                              <svg
                                width="6"
                                height="9"
                                viewBox="0 0 6 9"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="1.49805"
                                  y="0.818359"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(45 1.49805 0.818359)"
                                  fill="#1D1D1D"
                                />
                                <rect
                                  x="5.58984"
                                  y="4.90918"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(135 5.58984 4.90918)"
                                  fill="#1D1D1D"
                                />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li className="category-item">
                      <a href="/Collection/LabCoat">
                        <div className="flex justify-between items-center px-5 h-10 bg-white hover:bg-qyellow transition-all duration-300 ease-in-out cursor-pointer">
                          <div className="flex items-center space-x-6">
                            <span> 
                            </span>
                            <span className="text-xs font-400">LAB COATS</span>
                          </div>
                          <div>
                            <span>
                              <svg
                                width="6"
                                height="9"
                                viewBox="0 0 6 9"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="1.49805"
                                  y="0.818359"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(45 1.49805 0.818359)"
                                  fill="#1D1D1D"
                                />
                                <rect
                                  x="5.58984"
                                  y="4.90918"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(135 5.58984 4.90918)"
                                  fill="#1D1D1D"
                                />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li className="category-item ">
                      <a href="/Accessory/Mask">
                        <div className="flex justify-between items-center px-5 h-10 bg-white hover:bg-qyellow transition-all duration-300 ease-in-out cursor-pointer">
                          <div className="flex items-center space-x-6">
                            <span> 
                            </span>
                            <span className="text-xs font-400">MASKS</span>
                          </div>
                          <div>
                            <span>
                              <svg
                                width="6"
                                height="9"
                                viewBox="0 0 6 9"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="1.49805"
                                  y="0.818359"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(45 1.49805 0.818359)"
                                  fill="#1D1D1D"
                                />
                                <rect
                                  x="5.58984"
                                  y="4.90918"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(135 5.58984 4.90918)"
                                  fill="#1D1D1D"
                                />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li className="category-item ">
                      <a href="/Collection/Matrix">
                        <div className="flex justify-between items-center px-5 h-10 bg-white hover:bg-qyellow transition-all duration-300 ease-in-out cursor-pointer">
                          <div className="flex items-center space-x-6">
                            <span> 
                            </span>
                            <span className="text-xs font-400">MATRIX</span>
                          </div>
                          <div>
                            <span>
                              <svg
                                width="6"
                                height="9"
                                viewBox="0 0 6 9"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="1.49805"
                                  y="0.818359"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(45 1.49805 0.818359)"
                                  fill="#1D1D1D"
                                />
                                <rect
                                  x="5.58984"
                                  y="4.90918"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(135 5.58984 4.90918)"
                                  fill="#1D1D1D"
                                />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li className="category-item">
                      <a href="/Collection/MatrixMens">
                        <div className="flex justify-between items-center px-5 h-10 bg-white hover:bg-qyellow transition-all duration-300 ease-in-out cursor-pointer">
                          <div className="flex items-center space-x-6">
                            <span> 
                            </span>
                            <span className="text-xs font-400">
                              MATRIX MENS
                            </span>
                          </div>
                          <div>
                            <span>
                              <svg
                                width="6"
                                height="9"
                                viewBox="0 0 6 9"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="1.49805"
                                  y="0.818359"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(45 1.49805 0.818359)"
                                  fill="#1D1D1D"
                                />
                                <rect
                                  x="5.58984"
                                  y="4.90918"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(135 5.58984 4.90918)"
                                  fill="#1D1D1D"
                                />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </a>
                    </li>

                    <li className="category-item ">
                      <a href="/Collection/MatrixUnderscrub">
                        <div className="flex justify-between items-center px-5 h-10 bg-white hover:bg-qyellow transition-all duration-300 ease-in-out cursor-pointer">
                          <div className="flex items-center space-x-6">
                            <span> 
                            </span>
                            <span className="text-xs font-400">
                              MATRIX UNDERSCRUB
                            </span>
                          </div>
                          <div>
                            <span>
                              <svg
                                width="6"
                                height="9"
                                viewBox="0 0 6 9"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="1.49805"
                                  y="0.818359"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(45 1.49805 0.818359)"
                                  fill="#1D1D1D"
                                />
                                <rect
                                  x="5.58984"
                                  y="4.90918"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(135 5.58984 4.90918)"
                                  fill="#1D1D1D"
                                />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li className="category-item">
                      <a href="/Collection/MatrixBasic">
                        <div className=" flex justify-between items-center px-5 h-10 bg-white hover:bg-qyellow transition-all duration-300 ease-in-out cursor-pointer">
                          <div className="flex items-center space-x-6">
                            <span> 
                            </span>
                            <span className="text-xs font-400">
                              MATRIX UNISEX BASIC
                            </span>
                          </div>
                          <div>
                            <span>
                              <svg
                                width="6"
                                height="9"
                                viewBox="0 0 6 9"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="1.49805"
                                  y="0.818359"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(45 1.49805 0.818359)"
                                  fill="#1D1D1D"
                                />
                                <rect
                                  x="5.58984"
                                  y="4.90918"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(135 5.58984 4.90918)"
                                  fill="#1D1D1D"
                                />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li className="category-item">
                      <a href="/Collection/MatrixImpulse">
                        <div className=" flex justify-between items-center px-5 h-10 bg-white hover:bg-qyellow transition-all duration-300 ease-in-out cursor-pointer">
                          <div className="flex items-center space-x-6">
                            <span> 
                            </span>
                            <span className="text-xs font-400">
                              MATRIX IMPULSE
                            </span>
                          </div>
                          <div>
                            <span>
                              <svg
                                width="6"
                                height="9"
                                viewBox="0 0 6 9"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="1.49805"
                                  y="0.818359"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(45 1.49805 0.818359)"
                                  fill="#1D1D1D"
                                />
                                <rect
                                  x="5.58984"
                                  y="4.90918"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(135 5.58984 4.90918)"
                                  fill="#1D1D1D"
                                />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </a>
                    </li>

                    <li className="category-item">
                      <a href="/Collection/MatrixPro">
                        <div className="flex justify-between items-center px-5 h-10 bg-white hover:bg-qyellow transition-all duration-300 ease-in-out cursor-pointer">
                          <div className="flex items-center space-x-6">
                            <span> 
                            </span>
                            <span className="text-xs font-400">MATRIX PRO</span>
                          </div>
                          <div>
                            <span>
                              <svg
                                width="6"
                                height="9"
                                viewBox="0 0 6 9"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="1.49805"
                                  y="0.818359"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(45 1.49805 0.818359)"
                                  fill="#1D1D1D"
                                />
                                <rect
                                  x="5.58984"
                                  y="4.90918"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(135 5.58984 4.90918)"
                                  fill="#1D1D1D"
                                />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li className="category-item">
                      <a href="/Collection/MatrixProMens">
                        <div className="flex justify-between items-center px-5 h-10 bg-white hover:bg-qyellow transition-all duration-300 ease-in-out cursor-pointer">
                          <div className="flex items-center space-x-6">
                            <span> 
                            </span>
                            <span className="text-xs font-400">
                              MATRIX PRO MENS
                            </span>
                          </div>
                          <div>
                            <span>
                              <svg
                                width="6"
                                height="9"
                                viewBox="0 0 6 9"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="1.49805"
                                  y="0.818359"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(45 1.49805 0.818359)"
                                  fill="#1D1D1D"
                                />
                                <rect
                                  x="5.58984"
                                  y="4.90918"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(135 5.58984 4.90918)"
                                  fill="#1D1D1D"
                                />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li className="category-item">
                      <a href="/Collection/Momentum">
                        <div className="flex justify-between items-center px-5 h-10 bg-white hover:bg-qyellow transition-all duration-300 ease-in-out cursor-pointer">
                          <div className="flex items-center space-x-6">
                            <span> 
                            </span>
                            <span className="text-xs font-400">MOMENTUM</span>
                          </div>
                          <div>
                            <span>
                              <svg
                                width="6"
                                height="9"
                                viewBox="0 0 6 9"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="1.49805"
                                  y="0.818359"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(45 1.49805 0.818359)"
                                  fill="#1D1D1D"
                                />
                                <rect
                                  x="5.58984"
                                  y="4.90918"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(135 5.58984 4.90918)"
                                  fill="#1D1D1D"
                                />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li className="category-item">
                      <a href="/Collection/MomentumMens">
                        <div className="flex justify-between items-center px-5 h-10 bg-white hover:bg-qyellow transition-all duration-300 ease-in-out cursor-pointer">
                          <div className="flex items-center space-x-6">
                            <span> 
                            </span>
                            <span className="text-xs font-400">
                              MOMENTUM MENS
                            </span>
                          </div>
                          <div>
                            <span>
                              <svg
                                width="6"
                                height="9"
                                viewBox="0 0 6 9"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="1.49805"
                                  y="0.818359"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(45 1.49805 0.818359)"
                                  fill="#1D1D1D"
                                />
                                <rect
                                  x="5.58984"
                                  y="4.90918"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(135 5.58984 4.90918)"
                                  fill="#1D1D1D"
                                />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li className="category-item">
                      <a href="/Collection/MomentumLabCoats">
                        <div className="flex justify-between items-center px-5 h-10 bg-white hover:bg-qyellow transition-all duration-300 ease-in-out cursor-pointer">
                          <div className="flex items-center space-x-6">
                            <span> 
                            </span>
                            <span className="text-xs font-400">
                              MOMENTUM LAB COATS
                            </span>
                          </div>
                          <div>
                            <span>
                              <svg
                                width="6"
                                height="9"
                                viewBox="0 0 6 9"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="1.49805"
                                  y="0.818359"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(45 1.49805 0.818359)"
                                  fill="#1D1D1D"
                                />
                                <rect
                                  x="5.58984"
                                  y="4.90918"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(135 5.58984 4.90918)"
                                  fill="#1D1D1D"
                                />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </a>
                    </li>
                    {/* PrimaFlex */}
                    {/* <li className="category-item">
                      <a href="/Collection/PrimaFlex">
                        <div className="flex justify-between items-center px-5 h-10 bg-white hover:bg-qyellow transition-all duration-300 ease-in-out cursor-pointer">
                          <div className="flex items-center space-x-6">
                            <span>
                              <svg
                                width="13"
                                height="20"
                                viewBox="0 0 13 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M3.31426 0.0918814C3.24257 0.171032 3.23113 0.325861 3.23113 1.21433C3.23113 2.50658 3.15969 2.41116 4.12673 2.41116H4.83857V3.13175C4.83857 3.96807 4.86197 4.0186 5.24917 4.0186C5.61644 4.0186 5.64229 3.95971 5.64229 3.123V2.41116H6.04415H6.44601V3.13175C6.44601 3.96807 6.46941 4.0186 6.85661 4.0186C7.22388 4.0186 7.24973 3.95971 7.24973 3.123V2.41116H7.95964H8.66949L9.91204 2.81302C11.7169 3.39672 11.6377 3.42919 11.6609 2.09778C11.6835 0.799606 11.8321 0.965236 10.1393 0.401282L8.93484 0H6.16612C3.5476 0 3.3929 0.00501528 3.31426 0.0918814ZM9.76801 1.15749L10.8665 1.51125V1.86077C10.8665 2.05296 10.8567 2.21023 10.8447 2.21023C10.8327 2.21023 10.4338 2.07463 9.95814 1.90887L9.09334 1.60744H6.56412H4.03485V1.20558V0.803721H6.3522H8.66955L9.76801 1.15749ZM3.31426 4.51235C3.26276 4.56925 3.23113 4.69045 3.23113 4.83107C3.23113 5.24457 3.10124 5.22418 5.73417 5.22418H8.05345V5.94477C8.05345 6.81857 8.0458 6.80687 8.66318 6.87702C9.8552 7.01243 10.7289 7.70594 11.1059 8.81579L11.2423 9.21765L11.2577 14.0526L11.273 18.8874H6.04415H0.815334L0.833016 14.0526C0.852627 8.69008 0.834367 8.98515 1.18852 8.31349C1.78481 7.1825 2.51067 6.88248 4.73813 6.84629C6.48542 6.81787 6.44601 6.82751 6.44601 6.42977C6.44601 6.0173 6.49262 6.02791 4.67937 6.02791C3.26938 6.02791 3.05424 6.03871 2.70986 6.12679C1.46712 6.44462 0.433342 7.47737 0.115969 8.71812C-0.0335875 9.30297 -0.0409175 19.4731 0.108124 19.608C0.257874 19.7436 11.8661 19.735 11.9889 19.5993C12.1293 19.4442 12.1146 9.27436 11.9732 8.72153C11.7594 7.88591 11.1936 7.09377 10.475 6.62446C10.0093 6.3202 9.70899 6.20466 8.99528 6.05497L8.85717 6.02598V5.30636C8.85717 4.67296 8.84618 4.57677 8.76529 4.5036C8.61657 4.36903 3.43643 4.37732 3.31426 4.51235ZM6.94837 6.1284C6.69021 6.38649 6.88105 6.83163 7.24973 6.83163C7.51766 6.83163 7.65159 6.69769 7.65159 6.42977C7.65159 6.29583 7.61809 6.19534 7.55116 6.1284C7.48416 6.0614 7.38366 6.02791 7.24973 6.02791C7.1158 6.02791 7.0153 6.0614 6.94837 6.1284ZM1.70682 9.33467C1.57167 9.48403 1.58009 17.4761 1.71557 17.5987C1.86499 17.7339 10.2589 17.7255 10.3815 17.59C10.5166 17.4406 10.5082 9.44854 10.3727 9.32592C10.2233 9.19071 1.82944 9.19913 1.70682 9.33467ZM9.66089 13.4623V16.8781H6.04415H2.4274V13.4623V10.0465H6.04415H9.66089V13.4623ZM5.73031 10.9684C5.38188 11.2914 4.60967 12.443 4.27706 13.1358C3.57139 14.6055 4.44706 16.0493 6.04415 16.0493C7.27776 16.0493 8.02831 15.3158 8.02831 14.1103V13.5757L7.74186 13C7.46538 12.4444 6.78299 11.4249 6.42846 11.0378C6.21434 10.8041 5.93741 10.7765 5.73031 10.9684ZM6.45707 12.5367C7.21424 13.6454 7.34913 14.1291 7.04771 14.6547C6.33516 15.8971 4.4277 14.9482 4.99192 13.6319C5.20712 13.13 5.96423 11.9873 6.06042 12.0194C6.09128 12.0296 6.26977 12.2625 6.45707 12.5367Z"
                                  fill="black"
                                />
                              </svg>
                            </span>
                            <span className="text-xs font-400">PRIMAFLEX</span>
                          </div>
                          <div>
                            <span>
                              <svg
                                width="6"
                                height="9"
                                viewBox="0 0 6 9"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="1.49805"
                                  y="0.818359"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(45 1.49805 0.818359)"
                                  fill="#1D1D1D"
                                />
                                <rect
                                  x="5.58984"
                                  y="4.90918"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(135 5.58984 4.90918)"
                                  fill="#1D1D1D"
                                />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </a>
                    </li> 
                    */}

                    <li className="category-item">
                      <a href="/Collection/Prints">
                        <div className="flex justify-between items-center px-5 h-10 bg-white hover:bg-qyellow transition-all duration-300 ease-in-out cursor-pointer">
                          <div className="flex items-center space-x-6">
                            <span> 
                            </span>
                            <span className="text-xs font-400">PRINTS</span>
                          </div>
                          <div>
                            <span>
                              <svg
                                width="6"
                                height="9"
                                viewBox="0 0 6 9"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="1.49805"
                                  y="0.818359"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(45 1.49805 0.818359)"
                                  fill="#1D1D1D"
                                />
                                <rect
                                  x="5.58984"
                                  y="4.90918"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(135 5.58984 4.90918)"
                                  fill="#1D1D1D"
                                />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </a>
                    </li>

                    {/* PureSoft */}
                    {/* 
                    <li className="category-item">
                      <a href="/Collection/PureSoft">
                        <div className="flex justify-between items-center px-5 h-10 bg-white hover:bg-qyellow transition-all duration-300 ease-in-out cursor-pointer">
                          <div className="flex items-center space-x-6">
                            <span>
                              <svg
                                width="13"
                                height="20"
                                viewBox="0 0 13 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M3.31426 0.0918814C3.24257 0.171032 3.23113 0.325861 3.23113 1.21433C3.23113 2.50658 3.15969 2.41116 4.12673 2.41116H4.83857V3.13175C4.83857 3.96807 4.86197 4.0186 5.24917 4.0186C5.61644 4.0186 5.64229 3.95971 5.64229 3.123V2.41116H6.04415H6.44601V3.13175C6.44601 3.96807 6.46941 4.0186 6.85661 4.0186C7.22388 4.0186 7.24973 3.95971 7.24973 3.123V2.41116H7.95964H8.66949L9.91204 2.81302C11.7169 3.39672 11.6377 3.42919 11.6609 2.09778C11.6835 0.799606 11.8321 0.965236 10.1393 0.401282L8.93484 0H6.16612C3.5476 0 3.3929 0.00501528 3.31426 0.0918814ZM9.76801 1.15749L10.8665 1.51125V1.86077C10.8665 2.05296 10.8567 2.21023 10.8447 2.21023C10.8327 2.21023 10.4338 2.07463 9.95814 1.90887L9.09334 1.60744H6.56412H4.03485V1.20558V0.803721H6.3522H8.66955L9.76801 1.15749ZM3.31426 4.51235C3.26276 4.56925 3.23113 4.69045 3.23113 4.83107C3.23113 5.24457 3.10124 5.22418 5.73417 5.22418H8.05345V5.94477C8.05345 6.81857 8.0458 6.80687 8.66318 6.87702C9.8552 7.01243 10.7289 7.70594 11.1059 8.81579L11.2423 9.21765L11.2577 14.0526L11.273 18.8874H6.04415H0.815334L0.833016 14.0526C0.852627 8.69008 0.834367 8.98515 1.18852 8.31349C1.78481 7.1825 2.51067 6.88248 4.73813 6.84629C6.48542 6.81787 6.44601 6.82751 6.44601 6.42977C6.44601 6.0173 6.49262 6.02791 4.67937 6.02791C3.26938 6.02791 3.05424 6.03871 2.70986 6.12679C1.46712 6.44462 0.433342 7.47737 0.115969 8.71812C-0.0335875 9.30297 -0.0409175 19.4731 0.108124 19.608C0.257874 19.7436 11.8661 19.735 11.9889 19.5993C12.1293 19.4442 12.1146 9.27436 11.9732 8.72153C11.7594 7.88591 11.1936 7.09377 10.475 6.62446C10.0093 6.3202 9.70899 6.20466 8.99528 6.05497L8.85717 6.02598V5.30636C8.85717 4.67296 8.84618 4.57677 8.76529 4.5036C8.61657 4.36903 3.43643 4.37732 3.31426 4.51235ZM6.94837 6.1284C6.69021 6.38649 6.88105 6.83163 7.24973 6.83163C7.51766 6.83163 7.65159 6.69769 7.65159 6.42977C7.65159 6.29583 7.61809 6.19534 7.55116 6.1284C7.48416 6.0614 7.38366 6.02791 7.24973 6.02791C7.1158 6.02791 7.0153 6.0614 6.94837 6.1284ZM1.70682 9.33467C1.57167 9.48403 1.58009 17.4761 1.71557 17.5987C1.86499 17.7339 10.2589 17.7255 10.3815 17.59C10.5166 17.4406 10.5082 9.44854 10.3727 9.32592C10.2233 9.19071 1.82944 9.19913 1.70682 9.33467ZM9.66089 13.4623V16.8781H6.04415H2.4274V13.4623V10.0465H6.04415H9.66089V13.4623ZM5.73031 10.9684C5.38188 11.2914 4.60967 12.443 4.27706 13.1358C3.57139 14.6055 4.44706 16.0493 6.04415 16.0493C7.27776 16.0493 8.02831 15.3158 8.02831 14.1103V13.5757L7.74186 13C7.46538 12.4444 6.78299 11.4249 6.42846 11.0378C6.21434 10.8041 5.93741 10.7765 5.73031 10.9684ZM6.45707 12.5367C7.21424 13.6454 7.34913 14.1291 7.04771 14.6547C6.33516 15.8971 4.4277 14.9482 4.99192 13.6319C5.20712 13.13 5.96423 11.9873 6.06042 12.0194C6.09128 12.0296 6.26977 12.2625 6.45707 12.5367Z"
                                  fill="black"
                                />
                              </svg>
                            </span>
                            <span className="text-xs font-400">PURE SOFT</span>
                          </div>
                          <div>
                            <span>
                              <svg
                                width="6"
                                height="9"
                                viewBox="0 0 6 9"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="1.49805"
                                  y="0.818359"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(45 1.49805 0.818359)"
                                  fill="#1D1D1D"
                                />
                                <rect
                                  x="5.58984"
                                  y="4.90918"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(135 5.58984 4.90918)"
                                  fill="#1D1D1D"
                                />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </a>
                    </li>
                    */}
                    <li className="category-item">
                      <a href="/Collection/ReadyGO">
                        <div className="flex justify-between items-center px-5 h-10 bg-white hover:bg-qyellow transition-all duration-300 ease-in-out cursor-pointer">
                          <div className="flex items-center space-x-6">
                            <span> 
                            </span>
                            <span className="text-xs font-400">READY GO</span>
                          </div>
                          <div>
                            <span>
                              <svg
                                width="6"
                                height="9"
                                viewBox="0 0 6 9"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="1.49805"
                                  y="0.818359"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(45 1.49805 0.818359)"
                                  fill="#1D1D1D"
                                />
                                <rect
                                  x="5.58984"
                                  y="4.90918"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(135 5.58984 4.90918)"
                                  fill="#1D1D1D"
                                />
                              </svg>{" "}
                            </span>
                          </div>
                        </div>
                      </a>
                    </li>

                    <li className="category-item">
                      <a href="/Collection/RedPanda">
                        <div className="flex justify-between items-center px-5 h-10 bg-white hover:bg-qyellow transition-all duration-300 ease-in-out cursor-pointer">
                          <div className="flex items-center space-x-6">
                            <span> 
                            </span>
                            <span className="text-xs font-400">RED PANDA</span>
                          </div>
                          <div>
                            <span>
                              <svg
                                width="6"
                                height="9"
                                viewBox="0 0 6 9"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="1.49805"
                                  y="0.818359"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(45 1.49805 0.818359)"
                                  fill="#1D1D1D"
                                />
                                <rect
                                  x="5.58984"
                                  y="4.90918"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(135 5.58984 4.90918)"
                                  fill="#1D1D1D"
                                />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li className="category-item">
                      <a href="/Accessory/ScrubCap">
                        <div className="flex justify-between items-center px-5 h-10 bg-white hover:bg-qyellow transition-all duration-300 ease-in-out cursor-pointer">
                          <div className="flex items-center space-x-6">
                            <span> 
                            </span>
                            <span className="text-xs font-400">SCRUB CAPS</span>
                          </div>
                          <div>
                            <span>
                              <svg
                                width="6"
                                height="9"
                                viewBox="0 0 6 9"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="1.49805"
                                  y="0.818359"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(45 1.49805 0.818359)"
                                  fill="#1D1D1D"
                                />
                                <rect
                                  x="5.58984"
                                  y="4.90918"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(135 5.58984 4.90918)"
                                  fill="#1D1D1D"
                                />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li className="category-item">
                      <a href="/Accessory/ScrunchieDuo">
                        <div className="flex justify-between items-center px-5 h-10 bg-white hover:bg-qyellow transition-all duration-300 ease-in-out cursor-pointer">
                          <div className="flex items-center space-x-6">
                            <span> 
                            </span>
                            <span className="text-xs font-400">
                              SCRUNCHIE DUO
                            </span>
                          </div>
                          <div>
                            <span>
                              <svg
                                width="6"
                                height="9"
                                viewBox="0 0 6 9"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="1.49805"
                                  y="0.818359"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(45 1.49805 0.818359)"
                                  fill="#1D1D1D"
                                />
                                <rect
                                  x="5.58984"
                                  y="4.90918"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(135 5.58984 4.90918)"
                                  fill="#1D1D1D"
                                />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li className="category-item">
                      <a href="/Collection/Smart">
                        <div className="flex justify-between items-center px-5 h-10 bg-white hover:bg-qyellow transition-all duration-300 ease-in-out cursor-pointer">
                          <div className="flex items-center space-x-6">
                            <span> 
                            </span>
                            <span className="text-xs font-400">SMART</span>
                          </div>
                          <div>
                            <span>
                              <svg
                                width="6"
                                height="9"
                                viewBox="0 0 6 9"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="1.49805"
                                  y="0.818359"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(45 1.49805 0.818359)"
                                  fill="#1D1D1D"
                                />
                                <rect
                                  x="5.58984"
                                  y="4.90918"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(135 5.58984 4.90918)"
                                  fill="#1D1D1D"
                                />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li className="category-item">
                      <a href="/Collection/TRUTC">
                        <div className="flex justify-between items-center px-5 h-10 bg-white hover:bg-qyellow transition-all duration-300 ease-in-out cursor-pointer">
                          <div className="flex items-center space-x-6">
                            <span></span>
                            <span className="text-xs font-400">TRU TC</span>
                          </div>
                          <div>
                            <span>
                              <svg
                                width="6"
                                height="9"
                                viewBox="0 0 6 9"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="1.49805"
                                  y="0.818359"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(45 1.49805 0.818359)"
                                  fill="#1D1D1D"
                                />
                                <rect
                                  x="5.58984"
                                  y="4.90918"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(135 5.58984 4.90918)"
                                  fill="#1D1D1D"
                                />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li className="category-item">
                      <a href="/Collection/IRGALL">
                        <div className="flex justify-between items-center px-5 h-10 bg-white hover:bg-qyellow transition-all duration-300 ease-in-out cursor-pointer">
                          <div className="flex items-center space-x-6">
                            <span></span>
                            <span className="text-xs font-400">IRG</span>
                          </div>
                          <div>
                            <span onClick={handleIRGButtonClick}>
                              <svg
                                width="6"
                                height="9"
                                viewBox="0 0 6 9"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="1.49805"
                                  y="0.818359"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(45 1.49805 0.818359)"
                                  fill="#1D1D1D"
                                />
                                <rect
                                  x="5.58984"
                                  y="4.90918"
                                  width="5.78538"
                                  height="1.28564"
                                  transform="rotate(135 5.58984 4.90918)"
                                  fill="#1D1D1D"
                                />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              {/* Navigator */}
              <div className="nav">
                <ul
                  className="nav-wrapper flex space-x-7 "
                  style={{ marginLeft: "10px" }}
                >
                  {/* Home page */}
                  {/*<li className="relative">
                    <Link to="/">
                      <span
                        className="flex items-center cursor-pointer "
                        style={{
                          color: "white",
                          fontFamily: "Roboto",
                          fontSize: "16px",
                          fontStyle: "normal",
                          fontWeight: "700",
                          lineHeight: "normal",
                        }}
                      >
                        <span>HOME</span>
                      </span>
                    </Link>
                  </li> */}

                  {/* Shop */}
                  <li>
                    <span
                      className="flex items-center text-sm font-600 cursor-pointer "
                      style={{
                        color: "white",
                        fontFamily: "Roboto",
                        fontSize: "16px",
                        fontStyle: "normal",
                        fontWeight: "700",
                        lineHeight: "normal",
                        marginLeft: "10px",
                      }}
                    >
                      <span>SCRUBS</span>
                      {/*  <span className="ml-1.5 ">
                        <Arrow className="fill-current" />
                       </span> */}
                    </span>
                    <div className="sub-menu w-full absolute left-0 top-[60px]">
                      <div
                        className="mega-menu-wrapper w-full bg-white flex justify-between items-center pl-[30px] py-[30px]"
                        style={{
                          minHeight: "295px",
                          boxShadow: "0px 15px 50px 0px rgba(0, 0, 0, 0.14)",
                        }}
                      > 
                          <div className="categories-wrapper"> 
                          <div>
                            <div className="category">
                              {/*<h1 className="text-[13px] font-700 text-qblack uppercase mb-[13px]">
                                Shop List
                                 </h1> */}
                            </div>
                            {/* Column 1 */}
                            <div className="category-items">
                              <ul className="flex flex-col space-y-2"> 
                                <li> 
                                  <a
                                    href="/Collection/Bestee"
                                    className="flex items-center space-x-1.5"
                                  >
                                    <span className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow cursor-pointer">
                                      Bestee
                                    </span>
                                    <div className="newCollection-badge">
                                      NEW
                                    </div>
                                  </a>
                                </li>
                                <li>
                                  <a href="/Collection/Blaze">
                                    <span className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow">
                                      Blaze
                                    </span>
                                  </a>
                                </li>
                                 <li>
                                  <a 
                                    href="/Collection/BlazeLite"
                                    className="flex items-center space-x-1.5"
                                  >
                                    <span
                                        className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow cursor-pointer"
                                        style={{ fontWeight: 700 }}
                                      >
                                      Blaze Lite
                                    </span>
                                      <div className="newCollection-badge">
                                        NEW
                                      </div>
                                  </a> 
                                </li>
                                 <li>
                                  <a
                                    href="/Collection/BlazeScuba"
                                    className="flex items-center space-x-1.5"
                                  >
                                    <span 
                                        className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow cursor-pointer"
                                        style={{ fontWeight: 700 }}
                                    >
                                      Blaze Scuba
                                    </span>
                                      <div className="newCollection-badge">
                                        NEW
                                      </div>
                                  </a>
                                </li>
                                <li>
                                  <a href="/Collection/Blossom">
                                    <span className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow">
                                      Blossom
                                    </span>
                                  </a>
                                </li>
                                <li>
                                  <a href="/Collection/BlossomSignature">
                                    <span className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow">
                                      Blossom Signature
                                    </span>
                                  </a>
                                </li>
                                <li>
                                  <a href="/Collection/Core">
                                    <span className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow">
                                      Core
                                    </span>
                                  </a>
                                </li> 
                              </ul>
                            </div>
                          </div>
                          <div>
                            <div className="category">
                              {/* <h1 className="text-[13px] font-700 text-qblack uppercase mb-[13px]">
                                Product Layouts
                                </h1> */}
                            </div>
                            {/* Column 2 */}
                            <div className="category-items">
                              <ul className="flex flex-col space-y-2">
                                 {/* Hide Embrace Only for Unimarket (UNIM10FL) */}
                                {!(
                                  userInfo?.result?.user?.userId === 559 &&
                                  userInfo?.result?.user?.loginId === "UNIM10FL"
                                ) && (
                                  <li>
                                    <a
                                      href="/Collection/Embrace"
                                      className="flex items-center space-x-1.5"
                                    >
                                      <span
                                        className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow cursor-pointer"
                                        style={{ fontWeight: 700 }}
                                      >
                                        Embrace
                                      </span>
                                      <div className="newCollection-badge">
                                        NEW
                                      </div>
                                    </a>
                                  </li>
                                )}
                                <li>
                                  <a href="/Collection/EON">
                                    <span className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow">
                                      EON
                                    </span>
                                  </a>
                                </li> 
                                <li>
                                  <a href="/Collection/Focus">
                                    <span className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow">
                                      Focus
                                    </span>
                                  </a>
                                </li>
                                <li>
                                  <a href="/Collection/Knits">
                                    <span className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow">
                                      Knits
                                    </span>
                                  </a>
                                </li>
                                <li>
                                  <a href="/Collection/LabCoat">
                                    <span className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow">
                                      Lab Coats
                                    </span>
                                  </a>
                                </li>
                                <li>
                                  <a href="/Collection/Matrix">
                                    <span className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow">
                                      Matrix
                                    </span>
                                  </a>
                                </li>
                                <li>
                                  <a href="/Collection/MatrixMens">
                                    <span className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow">
                                      Matrix Mens
                                    </span>
                                  </a>
                                </li> 
                              </ul>
                            </div>
                          </div>
                          <div>
                            <div className="category">
                              {/* <h1 className="text-[13px] font-700 text-qblack uppercase mb-[13px]">
                                Polular Category
                              </h1> */}
                            </div>
                             {/* Column 3 */}
                            <div className="category-items">
                              <ul className="flex flex-col space-y-2">
                                <li>
                                  <a href="/Collection/MatrixUnderscrub">
                                    <span className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow">
                                      Matrix Underscrub
                                    </span>
                                  </a>
                                </li>
                                <li>
                                  <a href="/Collection/MatrixBasic">
                                    <span className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow">
                                      Matrix Unisex Basic
                                    </span>
                                  </a>
                                </li>
                                <li>
                                  <a href="/Collection/MatrixImpulse">
                                    <span className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow">
                                      Matrix Impulse
                                    </span>
                                  </a>
                                </li>
                                <li>
                                  <a href="/Collection/MatrixPro">
                                    <span className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow">
                                      Matrix Pro
                                    </span>
                                  </a>
                                </li>
                                <li>
                                  <a href="/Collection/MatrixProMens">
                                    <span className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow">
                                      Matrix Pro Mens
                                    </span>
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href="/Collection/Momentum"
                                    className="flex items-center space-x-1.5"
                                  >
                                    <span className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow cursor-pointer">
                                      Momentum
                                    </span>
                                    <div className="newCollection-badge">
                                      NEW
                                    </div>
                                  </a>
                                </li>
                                <li>
                                  <a href="/Collection/MomentumMens">
                                    <span className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow">
                                      Momentum Mens
                                    </span>
                                  </a>
                                </li> 

                                {/* PrimaFlex */}
                                {/*
                                 <li>
                                  <a href="/Collection/PrimaFlex">
                                    <span className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow">
                                      PrimaFlex
                                    </span>
                                  </a>
                                </li>
                                */}

                                {/* PureSoft */}
                                {/*
                                <li>
                                  <a href="/Collection/PureSoft">
                                    <span className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow">
                                      Pure Soft
                                    </span>
                                  </a>
                                </li>
                                 */}
                              </ul>
                            </div>
                          </div>
                          <div>
                            <div className="category">
                              {/* <h1 className="text-[13px] font-700 text-qblack uppercase mb-[13px]">
                                Polular Category
                              </h1> */}
                            </div>
                             {/* Column 4 */}
                            <div className="category-items">
                              <ul className="flex flex-col space-y-2">
                                 <li>
                                  <a href="/Collection/MomentumLabCoats">
                                    <span className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow">
                                      Momentum Lab Coats
                                    </span>
                                  </a>
                                </li>
                                <li>
                                  <a href="/Collection/RedPanda">
                                    <span className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow">
                                      Red Panda
                                    </span>
                                  </a>
                                </li> 
                                <li>
                                  <a href="/Collection/Smart">
                                    <span className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow">
                                      Smart
                                    </span>
                                  </a>
                                </li>
                                <li>
                                  <a href="/Collection/TRUTC">
                                    <span className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow cursor-pointer">
                                      TRU TC
                                    </span>
                                  </a>
                                </li>
                                <li> 
                                <a className="flex items-center space-x-1.5">
                                  <span className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow cursor-pointer"
                                     onClick={handleIRGButtonClick} >
                                    IRG / TEMPO
                                  </span>
                                  <div className="newCollection-badge">
                                    EXCL
                                  </div>  
                                  </a> 
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        {/* <div className="thumbnil w-[348px] h-full">
                          <div className="w-full h-[235px]">
                            <img
                              width=""
                              src={`${process.env.PUBLIC_URL}/assets/images/mega-menu-thumb.jpg`}
                              alt=""
                              className="w-full h-full object-contain"
                            />
                            </div> 
                        </div> */}
                      </div>
                    </div>
                  </li>
                  {/* Prints */}
                  <li>
                    <Link to="/Collection/Prints">
                      <span
                        className="flex items-center text-sm font-600 cursor-pointer "
                        style={{
                          color: "white",
                          fontFamily: "Roboto",
                          fontSize: "16px",
                          fontStyle: "normal",
                          fontWeight: "700",
                          lineHeight: "normal",
                          marginLeft: "10px",
                        }}
                      >
                        <span>PRINTS</span>
                      </span>
                    </Link>
                  </li>
                  {/* Bags */}
                  <li className="relative">
                    <a
                      href="/Accessory/ReadyGo" // Replace this with the specific URL you want to link to
                      className="flex items-center text-sm font-600 cursor-pointer"
                      style={{
                        color: "white",
                        fontFamily: "Roboto",
                        fontSize: "16px",
                        fontStyle: "normal",
                        fontWeight: "700",
                        lineHeight: "normal",
                        marginLeft: "10px",
                      }}
                    >
                      <span>READYGO BAGS</span>
                      {/*  <span className="ml-1.5 ">
                        <Arrow className="fill-current" />
                      </span> */}
                    </a>
                    <div className="sub-menu w-[250px] absolute left-0 top-[60px]">
                      <div
                        className="w-full bg-white flex justify-between items-center "
                        style={{
                          boxShadow: "0px 15px 50px 0px rgba(0, 0, 0, 0.14)",
                        }}
                      >
                        <div className="readygo-categories-wrapper w-full h-full p-5">
                          <div>
                            <div className="category-items">
                              <ul className="flex flex-col space-y-3 mt-2 mt-2">
                                <li>
                                  <a href="/Bags/ReadyGo_LunchBag">
                                    <span className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow">
                                      ReadyGo Insulated Lunch Bag
                                    </span>
                                  </a>
                                </li>
                                <li>
                                  <a href="/Bags/ReadyGo_Backpack">
                                    <span className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow">
                                      ReadyGo Backpack
                                    </span>
                                  </a>
                                </li>
                                {/* <li>
                                  <a href="/Bags/ReadyGo_Satchel">
                                    <span className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow">
                                      ReadyGo Satchel
                                    </span>
                                  </a>
                                </li> */}
                                <li>
                                  <a href="/Bags/ReadyGo_Clutch">
                                    <span className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow">
                                      ReadyGo Clutch
                                    </span>
                                  </a>
                                </li>
                                <li>
                                  <a href="/Bags/ReadyGo_Stethoscope_Case">
                                    <span className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow">
                                      ReadyGo Stethoscope Case
                                    </span>
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  {/* Accessories */}
                  <li className="relative">
                    <span
                      className="flex items-center text-sm font-600 cursor-pointer "
                      style={{
                        color: "white",
                        fontFamily: "Roboto",
                        fontSize: "16px",
                        fontStyle: "normal",
                        fontWeight: "700",
                        lineHeight: "normal",
                        marginLeft: "10px",
                      }}
                    >
                      <span>ACCESSORIES</span>
                      {/*  <span className="ml-1.5 ">
                        <Arrow className="fill-current" />
                      </span> */}
                    </span>
                    <div className="sub-menu w-[220px] absolute left-0 top-[60px]">
                      <div
                        className="w-full bg-white flex justify-between items-center "
                        style={{
                          boxShadow: "0px 15px 50px 0px rgba(0, 0, 0, 0.14)",
                        }}
                      >
                        <div className="accessories-categories-wrapper w-full h-full p-5">
                          <div>
                            <div className="category-items">
                              <ul className="flex flex-col space-y-2">
                                {/* <li>
                                  <a href="/Accessory/PPEProducts">
                                    <span className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow">
                                      PPE Products
                                    </span>
                                  </a>
                                </li> */}
                                <li>
                                  <a href="/Accessory/ScrubCap">
                                    <span className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow">
                                      Scrub Caps
                                    </span>
                                  </a>
                                </li>
                                <li>
                                  <a href="/Accessory/ScrunchieDuo">
                                    <span
                                      className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow cursor-pointer"
                                      style={{ fontWeight: 700 }}
                                    >
                                      Scrunchie Duo
                                    </span>
                                    <div
                                      className="newCollection-badge"
                                      style={{ marginLeft: "8px" }}
                                    >
                                      NEW
                                    </div>
                                  </a>
                                </li>
                                <li>
                                  <a href="/Accessory/Mask">
                                    <span className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow">
                                      Masks
                                    </span>
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>

                  {/* Page */}
                  {/* 
                  <li className="relative">
                    <span className="flex items-center text-sm text-qblacktext font-600 cursor-pointer ">
                      <span>Pages</span>
                      <span className="ml-1.5 ">
                        <Arrow className="fill-current" />
                      </span>
                    </span>
                    <div className="sub-menu w-[220px] absolute left-0 top-[60px]">
                      <div
                        className="w-full bg-white flex justify-between items-center "
                        style={{
                          boxShadow: "0px 15px 50px 0px rgba(0, 0, 0, 0.14)",
                        }}
                      >
                        <div className="categories-wrapper w-full h-full p-5">
                          <div>
                            <div className="category-items">
                              <ul className="flex flex-col space-y-2">
                                <li>
                                  <a href="/privacy-policy">
                                    <span className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow">
                                      Privacy Policy
                                    </span>
                                  </a>
                                </li>
                                <li>
                                  <a href="/terms-conditions">
                                    <span className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow">
                                      Terms and Conditions
                                    </span>
                                  </a>
                                </li>
                                <li>
                                  <a href="/faq">
                                    <span className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow">
                                      FAQ
                                    </span>
                                  </a>
                                </li>
                                <li>
                                  <a href="/all-products">
                                    <span className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow">
                                      Shop Category Icon
                                    </span>
                                  </a>
                                </li>
                                <li>
                                  <a href="/all-products">
                                    <span className="text-qgray text-sm font-400 border-b border-transparent hover:border-qyellow hover:text-qyellow">
                                      Shop List View
                                    </span>
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  */}
                  {/* About */}
                  {/*<li>
                    <Link to="/about">
                      <span
                        className="flex items-center text-sm font-600 cursor-pointer "
                        style={{
                          color: "white",
                          fontFamily: "Roboto",
                          fontSize: "16px",
                          fontStyle: "normal",
                          fontWeight: "700",
                          lineHeight: "normal",
                        }}
                      >
                        <span>ABOUT</span>
                      </span>
                    </Link>
                  </li>*/}

                  {/* Catalog */}
                  {/* <li>
                    <a
                      // href="https://online.flippingbook.com/view/880264174/"
                      href="https://online.flippingbook.com/view/652672645/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span
                        className="flex items-center text-sm font-600 cursor-pointer "
                        style={{
                          color: "white",
                          fontFamily: "Roboto",
                          fontSize: "16px",
                          fontStyle: "normal",
                          fontWeight: "700",
                          lineHeight: "normal",
                          marginLeft: "10px",
                        }}
                      >
                        <span>CATALOG</span>
                      </span>
                    </a>
                  </li> 
                  */}

                  {/* Quick Order */}
                  {/*  <li>
                    <Link to="/quickorder">
                      <span
                        className="flex items-center text-sm font-600 cursor-pointer "
                        style={{
                          color: "white",
                          fontFamily: "Roboto",
                          fontSize: "16px",
                          fontStyle: "normal",
                          fontWeight: "700",
                          lineHeight: "normal",
                          marginLeft: "10px",
                        }}
                      >
                        <span>QUICK ORDER</span>
                      </span>
                    </Link>
                  </li> */}

                  <li>
                    {/* Map Price */}
                    {/*  
                    <Link to="/blogs">
                      <span className="flex items-center text-sm text-qblacktext font-600 cursor-pointer ">
                        <span>Map Price</span>
                      </span>
                    </Link>
                    */}
                  </li>
                </ul>
              </div>
            </div>

            {/* Quick order & Order import bundle */}
            <div className="quick-bulk-button-group flex items-center gap-3">
              {/* Quick order */}
              {shoppingCartPermission === 1 && placeOrderPermission === 1 && (
                <div className="become-seller-btn">
                  <Link to="/quickorder">
                    <div
                      className="black-btn w-[135px] h-[40px] flex justify-center items-center cursor-pointer"
                      style={{
                        display: "inline-flex",
                        height: "40px",
                        padding: "10px 20px",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "6px",
                        flexShrink: 0,
                        borderRadius: "5px",
                        border: "1px solid #04ADD1",
                        background: "#FDFDFD",
                        color: "#04ADD1",
                        fontFamily: "Roboto",
                        fontSize: "16px",
                        fontWeight: "700",
                        lineHeight: "normal",
                        transition:
                          "background 0.3s, color 0.3s, border-color 0.3s", // Smooth transition for background, color, and border
                      }}
                      onMouseOver={(e) => {
                        handleHoverQuickOrder(e); // Use a shared handler for hover and focus
                      }}
                      onMouseOut={(e) => {
                        handleHoverOutQuickOrder(e); // Use a shared handler for mouse out and blur
                      }}
                      onFocus={(e) => {
                        handleHoverQuickOrder(e); // Same as onMouseOver
                      }}
                      onBlur={(e) => {
                        handleHoverOutQuickOrder(e); // Same as onMouseOut
                      }}
                    >
                      <div className="flex space-x-2 items-center">
                        <span className="text-sm font-600">Quick Order </span>
                        <svg
                          width="6"
                          height="10"
                          viewBox="0 0 6 10"
                          fill="#04ADD1"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="1.08984"
                            width="6.94106"
                            height="1.54246"
                            transform="rotate(45 1.08984 0)"
                            fill="#04ADD1"
                          />
                          <rect
                            x="6"
                            y="4.9082"
                            width="6.94106"
                            height="1.54246"
                            transform="rotate(135 6 4.9082)"
                            fill="#04ADD1"
                          />
                        </svg>
                      </div>
                    </div>
                  </Link>
                </div>
              )}

              {/* Order Import */}
              {shoppingCartPermission === 1 && placeOrderPermission === 1 && (
                <div className="become-seller-btn">
                  <Link to="/bulkorder">
                    <div
                      className="black-btn w-[140px] h-[40px] flex justify-center items-center cursor-pointer"
                      style={{
                        display: "inline-flex",
                        height: "40px",
                        padding: "10px 20px",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "6px",
                        flexShrink: 0,
                        borderRadius: "5px",
                        border: "2px solid #FFFFFF",
                        background: "#04ADD1",
                        color: "#FDFDFD",
                        fontFamily: "Roboto",
                        fontSize: "16px",
                        fontWeight: "700",
                        lineHeight: "normal",
                        transition:
                          "background 0.3s, color 0.3s, border-color 0.3s", // Smooth transition for background, color, and border
                      }}
                      onMouseOver={(e) => {
                        handleHoverOrderImport(e); // Use a shared handler for hover and focus
                      }}
                      onMouseOut={(e) => {
                        handleHoverOutOrderImport(e); // Use a shared handler for mouse out and blur
                      }}
                      onFocus={(e) => {
                        handleHoverOrderImport(e); // Same as onMouseOver
                      }}
                      onBlur={(e) => {
                        handleHoverOutOrderImport(e); // Same as onMouseOut
                      }}
                    >
                      <div className="flex space-x-2 items-center">
                        <span className="text-sm font-600">Order Import </span>
                        <svg
                          width="6"
                          height="10"
                          viewBox="0 0 6 10"
                          fill="#FFFFFF"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="1.08984"
                            width="6.94106"
                            height="1.54246"
                            transform="rotate(45 1.08984 0)"
                            fill="#FFFFFF"
                          />
                          <rect
                            x="6"
                            y="4.9082"
                            width="6.94106"
                            height="1.54246"
                            transform="rotate(135 6 4.9082)"
                            fill="#FFFFFF"
                          />
                        </svg>
                      </div>
                    </div>
                  </Link>
                </div>
              )}
            </div>
            {/*    
            <div className="become-seller-btn">
            <Link to="/become-saller">
                <div className="black-btn w-[161px] h-[40px] flex justify-center items-center cursor-pointer">
                  <div className="flex space-x-2 items-center">
                    <span className="text-sm font-600">Become a Seller</span>
                    <span>
                      <svg
                        width="6"
                        height="10"
                        viewBox="0 0 6 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="1.08984"
                          width="6.94106"
                          height="1.54246"
                          transform="rotate(45 1.08984 0)"
                          fill="white"
                        />
                        <rect
                          x="6"
                          y="4.9082"
                          width="6.94106"
                          height="1.54246"
                          transform="rotate(135 6 4.9082)"
                          fill="white"
                        />
                      </svg>
                    </span>
                  </div>
                </div>
              </Link>
             </div> */}
          </div>
        </div>
      </div>
      {isIRGPopupOpen && (
        <div className="popup-overlay">
          <div
            className={`popup-container ${
              showIRGError ? "popup-container-error" : ""
            } ${failedAttempts >= 3 ? "popup-container-extended" : ""}`}
          >
            {/* Close Button */}
            <div className="close-button" onClick={closeIRGPopup}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="17"
                viewBox="0 0 17 17"
                fill="none"
              >
                <path
                  d="M16 1L1 16"
                  stroke="#474747"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
                <path
                  d="M1 1L16 16"
                  stroke="#474747"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </div>
            <div className="title-container">
              <img src={IRGlogo} alt="IRG Logo" className="company-logo" />
              <h2 className="title-text">Welcome IRG members!</h2>
            </div>

            <p className="subtitle-text">
              Please enter the password to access the page.
            </p>

            {failedAttempts >= 3 && (
              <div className="warning-message-container">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M9 8.98002C9 8.71481 9.10536 8.46045 9.29289 8.27292C9.48043 8.08538 9.73478 7.98002 10 7.98002C10.2652 7.98002 10.5196 8.08538 10.7071 8.27292C10.8946 8.46045 11 8.71481 11 8.98002V14.98C11 15.2452 10.8946 15.4996 10.7071 15.6871C10.5196 15.8747 10.2652 15.98 10 15.98C9.73478 15.98 9.48043 15.8747 9.29289 15.6871C9.10536 15.4996 9 15.2452 9 14.98V8.98002ZM10 4.05103C9.73478 4.05103 9.48043 4.15638 9.29289 4.34392C9.10536 4.53145 9 4.78581 9 5.05103C9 5.31624 9.10536 5.5706 9.29289 5.75813C9.48043 5.94567 9.73478 6.05102 10 6.05102C10.2652 6.05102 10.5196 5.94567 10.7071 5.75813C10.8946 5.5706 11 5.31624 11 5.05103C11 4.78581 10.8946 4.53145 10.7071 4.34392C10.5196 4.15638 10.2652 4.05103 10 4.05103Z"
                    fill="#FF4444"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10 0C4.477 0 0 4.477 0 10C0 15.523 4.477 20 10 20C15.523 20 20 15.523 20 10C20 4.477 15.523 0 10 0ZM2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10Z"
                    fill="#FF4444"
                  />
                </svg>
                <div className="warning-text">
                  <span className="warning-message1">
                    Forgot the password or need assistance?{" "}
                  </span>
                  <span className="warning-message2">
                    Please email support@irgscrubs.com or text 402-440-1846.
                  </span>{" "}
                </div>
              </div>
            )}

            <div className="passcode-container">
              <label className="password-label">Password</label>
              <div
                className={`input-icon-container ${
                  showIRGError ? "input-icon-container-error" : ""
                }`}
              >
                <input
                  placeholder="Enter your passsword"
                  // placeholder="Enter passcode"
                  className="passcode-input"
                  type="password"
                  id="entered_password"
                  value={enteredIRGPasscode}
                  onChange={(e) => setEnteredIRGPasscode(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      verifyIRGPasscode();
                    }
                  }}
                />
                {/* Show enetered passcode */}
                <div
                  className="password-icon"
                  onClick={() => showPasscode("entered_password")}
                >
                  {passcodePass === "show-password" ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                      />
                    </svg>
                  ) : (
                    <svg
                      width="25"
                      height="21"
                      viewBox="0 0 25 21"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20.5483 16.3524C20.156 15.9557 19.7696 15.5605 19.3802 15.1683C18.7802 14.5653 18.1787 13.9638 17.5728 13.3667C17.4972 13.2911 17.4871 13.2388 17.5379 13.1415C19.3482 9.66037 17.2125 5.46008 13.3332 4.87747C12.1143 4.69441 10.9534 4.89636 9.85791 5.46299C9.78672 5.49931 9.73587 5.53563 9.65596 5.45572C8.88157 4.67262 8.10136 3.89678 7.32261 3.11803C7.30082 3.09624 7.28338 3.07154 7.24561 3.0265C7.5667 2.90591 7.8689 2.78387 8.17837 2.67926C10.0758 2.03563 12.0242 1.83513 14.0132 2.05161C18.879 2.58337 23.1752 5.85381 24.9768 10.3926C25 10.4522 25.0073 10.5379 24.9826 10.596C24.0484 12.8916 22.5955 14.792 20.6282 16.2986C20.6137 16.3117 20.5963 16.3219 20.5483 16.3524Z"
                        fill="#797979"
                      />
                      <path
                        d="M4.44163 4.65918C4.91528 5.13573 5.3773 5.6021 5.84222 6.06703C6.36962 6.59442 6.89703 7.12327 7.42733 7.64776C7.49853 7.7175 7.51015 7.7669 7.4622 7.85989C5.81462 11.0228 7.40118 14.873 10.801 15.9336C12.2829 16.3956 13.7271 16.2576 15.1161 15.5573C15.1626 15.534 15.2076 15.5093 15.2468 15.489C16.0735 16.3186 16.893 17.1424 17.724 17.9778C17.6862 17.9952 17.6383 18.0199 17.5874 18.0403C15.5069 18.8844 13.3493 19.1909 11.1162 18.9657C6.18511 18.4674 1.87 15.2275 0.02773 10.6364C0.000124928 10.5666 -0.0114982 10.4693 0.0146539 10.4039C0.941602 8.12286 2.38433 6.23411 4.33557 4.73328C4.36317 4.71003 4.39514 4.69114 4.44163 4.65918Z"
                        fill="#797979"
                      />
                      <path
                        d="M2.04297 1.0577C2.36406 0.732254 2.72292 0.370486 3.09051 0C9.71717 6.64695 16.3482 13.2968 22.9749 19.9438C22.645 20.2721 22.2833 20.631 21.9128 21C15.2905 14.3531 8.66237 7.70174 2.04297 1.0577Z"
                        fill="#797979"
                      />
                      <path
                        d="M13.5471 13.7324C12.655 14.071 11.1164 14.0158 10.0093 12.8433C9.16664 11.9512 8.80197 10.3283 9.27125 9.46387C10.698 10.8877 12.116 12.3028 13.5471 13.7324Z"
                        fill="#797979"
                      />
                      <path
                        d="M11.519 7.24656C12.3123 6.80779 13.9425 7.17247 14.8389 8.01369C16.0172 9.11933 16.071 10.6638 15.7528 11.4933C14.342 10.0797 12.9269 8.66022 11.519 7.24656Z"
                        fill="#797979"
                      />
                    </svg>
                  )}
                </div>
              </div>
              {showIRGError && (
                <p className="error-message">Please enter a valid password</p>
              )}
            </div>
            <button
              onClick={verifyIRGPasscode}
              type="button"
              className="access-button"
            >
              Access
            </button>

              <div className="excl-only-bottom-message">
                <p className="excl-only-text">Distributed by invitation only through a limited elite network</p>
              </div>
            <div className="bottom-message">
              <p className="join-text">Interested in joining IRG?</p>
              <p className="apply-text">
                Apply at:{" "}
                <a
                  href="https://irgscrubs.com/new-retailer-application/"
                  target="_blank"
                  className="apply-link"
                >
                  https://irgscrubs.com/new-retailer-application/
                </a>
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
